import type { ReactNode } from 'react';
import { SIDEBAR_ID } from './PortalSidebar';

/** Props for {@link SidebarToggle}. */
export interface SidebarToggleProps {
  /** The menu glyph, rendered by the app. */
  icon: ReactNode;
  /** Whether the drawer this button controls is open. */
  expanded: boolean;
  onClick: () => void;
  /** Accessible name and tooltip. */
  label?: string;
}

/**
 * The button that opens the sidebar drawer. It only shows at 900px and below — above that the rail is always
 * on screen — so a topbar can render it unconditionally.
 */
export function SidebarToggle({ icon, expanded, onClick, label = 'Abrir menu' }: SidebarToggleProps) {
  return (
    <button
      type="button"
      className="pk-toggle"
      onClick={onClick}
      aria-controls={SIDEBAR_ID}
      aria-expanded={expanded}
      aria-label={label}
      title={label}
    >
      {icon}
    </button>
  );
}
